/** Logs temporales de depuración del Gantt (eliminar cuando se cierre el bug). */

let sequence = 0;

export type GhanttDebugPayload = Record<string, unknown>;

/**
 * Emite un log con prefijo `[Gantt:tag]`, secuencia incremental y `performance.now()`.
 */
export function ghanttDebugLog(
  tag: string,
  message: string,
  payload?: GhanttDebugPayload
): void {
  sequence += 1;
  const prefix = `[Gantt:${tag}] #${sequence} @${performance.now().toFixed(1)}ms`;

  if (payload !== undefined) {
    // eslint-disable-next-line no-console
    console.log(prefix, message, payload);
  } else {
    // eslint-disable-next-line no-console
    console.log(prefix, message);
  }
}
